export enum MembershipStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
}

export enum InvitationState {
  PENDING = "pending",
  ACCEPTED = "accepted",
  REVOKED = "revoked",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
}

/** Whether an entry pack has been paid for, which is independent of whether it has been used. */
export enum PaymentStatus {
  PAID = "paid",
  UNPAID = "unpaid",
  PARTIAL = "partial",
}

export enum EntryPackStatus {
  ACTIVE = "active",
  DEPLETED = "depleted",
  EXPIRED = "expired",
}

/** Shared by training and diet plans: a draft is still being written, an archived one is history. */
export enum PlanStatus {
  DRAFT = "draft",
  ACTIVE = "active",
  ARCHIVED = "archived",
}

/** Which of a progress entry's three value columns a metric's readings fill in. */
export enum ProgressMetricType {
  NUMERIC = "numeric",
  DATE = "date",
  TEXT = "text",
}

/** Which way a metric has to move to count as progress. */
export enum ProgressDirection {
  INCREASE = "increase",
  DECREASE = "decrease",
}
